export class MemberLabAttestationRequest {
    public memberCin: string;
    public measurementPeriod: string;
}
